import clsx from "clsx"
import {
  DEFAULT_GUARDIANS_MAP_FILTERS,
  GuardiansMapFilters,
  MAP_FILTER_LAYER_KEYS,
  mapLayerLabel,
} from "@/features/map/guardiansMapFilters"

type Props = {
  open: boolean
  filters: GuardiansMapFilters
  onChange: (next: GuardiansMapFilters) => void
  onClose: () => void
  showPlayersLayer?: boolean
}

export default function GuardiansMapFiltersPanel({
  open,
  filters,
  onChange,
  onClose,
  showPlayersLayer = true,
}: Props) {
  if (!open) return null

  const layers = showPlayersLayer
    ? MAP_FILTER_LAYER_KEYS
    : MAP_FILTER_LAYER_KEYS.filter((k) => k !== "players")

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 p-4"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="max-h-[70dvh] w-full max-w-md overflow-y-auto rounded-t-2xl border border-white/10 bg-guardians-bg p-4 shadow-xl"
        role="dialog"
        aria-label="Слои карты"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-lg font-semibold">Слои карты</h2>
          <button
            type="button"
            className="text-sm text-guardians-muted"
            onClick={onClose}
          >
            Закрыть
          </button>
        </div>

        <ul className="space-y-1">
          {layers.map((key) => (
            <li key={key}>
              <label className="flex cursor-pointer items-center justify-between rounded-lg px-2 py-2 hover:bg-white/5">
                <span className="text-sm">{mapLayerLabel(key)}</span>
                <input
                  type="checkbox"
                  checked={filters[key]}
                  onChange={() =>
                    onChange({ ...filters, [key]: !filters[key] })
                  }
                />
              </label>
            </li>
          ))}
        </ul>

        <label className="mt-3 flex cursor-pointer items-center justify-between border-t border-white/10 pt-3">
          <span className="text-sm">Только доступные</span>
          <input
            type="checkbox"
            checked={filters.onlyAvailable}
            onChange={() =>
              onChange({
                ...filters,
                onlyAvailable: !filters.onlyAvailable,
              })
            }
          />
        </label>

        <button
          type="button"
          className="mt-4 w-full rounded-xl border border-white/15 py-2 text-sm text-guardians-muted"
          onClick={() => onChange({ ...DEFAULT_GUARDIANS_MAP_FILTERS })}
        >
          Сбросить
        </button>
      </div>
    </div>
  )
}

export function MapFiltersToggleButton({
  activeCount,
  onClick,
  className,
}: {
  activeCount: number
  onClick: () => void
  className?: string
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        "rounded-lg border border-white/15 px-2 py-1 text-[10px] uppercase tracking-wide text-guardians-muted",
        className
      )}
    >
      Фильтры{activeCount > 0 ? ` (${activeCount})` : ""}
    </button>
  )
}
